/**
 *  app 管理 可管理 你在全局存入的任何数据
 *  
 *  
 */

 const state = {
    time:null
  }
  /* mutations 示例
      TOGGLE_SIDEBAR: state => {
      },
      CLOSE_SIDEBAR: (state, withoutAnimation) => {
      },
      TOGGLE_DEVICE: (state, device) => {
      },
      SYNCHRONOUS: (state, parmas)=>{} 
  */
  const mutations = {
  
  }
  /* actions  示例
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }, 
  */
  const actions = {
  
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }